type TeacherLike = {
  homeroomClass?: { grade: number; class: number };
};

export type ClassRoleRosterPrintRow = {
  studentNumber: number;
  studentName: string;
  roleName: string;
  position: string;
};

export const printClassRoleRoster = ({
  teacher,
  filterLabel,
  rows,
  title
}: {
  teacher: TeacherLike;
  filterLabel: string;
  rows: ClassRoleRosterPrintRow[];
  title?: string;
}) => {
  if (!rows.length) {
    alert('출력할 명단이 없습니다.');
    return;
  }

  const escapeHtml = (str: string) =>
    str
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');

  const classLabel = teacher.homeroomClass
    ? `${teacher.homeroomClass.grade}학년 ${teacher.homeroomClass.class}반`
    : '학급';

  const displayTitle =
    title?.trim() || `${classLabel} 학급 역할 명단`;

  const printedAt = new Date().toLocaleString('ko-KR', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  });

  const tableRows = rows
    .map(
      (r, i) => `
    <tr>
      <td>${i + 1}</td>
      <td>${escapeHtml(String(r.studentNumber))}</td>
      <td>${escapeHtml(r.studentName)}</td>
      <td>${escapeHtml(r.roleName)}</td>
      <td>${escapeHtml(r.position)}</td>
    </tr>`
    )
    .join('');

  const printWindow = window.open('', '_blank', 'width=900,height=700');
  if (!printWindow) {
    alert('팝업이 차단되어 인쇄 창을 열 수 없습니다. 브라우저 설정을 확인해 주세요.');
    return;
  }

  const printContent = `
    <!DOCTYPE html>
    <html lang="ko">
      <head>
        <meta charset="utf-8" />
        <title>${escapeHtml(displayTitle)}</title>
        <style>
          * { box-sizing: border-box; }
          body {
            font-family: 'Pretendard', 'Malgun Gothic', sans-serif;
            color: #161616;
            padding: 24px;
            margin: 0;
          }
          h1 {
            font-size: 22px;
            font-weight: 600;
            margin: 0 0 8px 0;
          }
          .meta {
            font-size: 13px;
            color: #555;
            margin-bottom: 20px;
          }
          table {
            width: 100%;
            border-collapse: collapse;
            font-size: 13px;
          }
          th, td {
            border: 1px solid #e0e0e0;
            padding: 10px 12px;
            text-align: left;
          }
          th {
            background: #f5f5f5;
            font-weight: 600;
          }
          tr:nth-child(even) td {
            background: #fafafa;
          }
          @media print {
            body { padding: 16px; }
            @page { margin: 12mm; }
          }
        </style>
      </head>
      <body>
        <h1>${escapeHtml(displayTitle)}</h1>
        <div class="meta">
          구분: ${escapeHtml(filterLabel)} · 출력: ${escapeHtml(printedAt)}
        </div>
        <table>
          <thead>
            <tr>
              <th>No</th>
              <th>번호</th>
              <th>이름</th>
              <th>역할</th>
              <th>직급</th>
            </tr>
          </thead>
          <tbody>
            ${tableRows}
          </tbody>
        </table>
        <script>
          window.onload = function () {
            setTimeout(function () {
              window.focus();
              window.print();
              window.close();
            }, 200);
          };
        </script>
      </body>
    </html>
  `;

  printWindow.document.open();
  printWindow.document.write(printContent);
  printWindow.document.close();
};
